var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.25V0H21.2L14.0136 6.77222L20.8733 13.25H0Z",
    fill: "#E04C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40901 9.42085H3.97461V3.9751H7.40901V4.74625H4.85706V6.28855H6.93201V7.05175H4.85706V8.64175H7.40901V9.42085Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6522 8.6497V9.42085H8.27345V8.6656L9.5693 7.33C9.7654 7.1286 9.9297 6.9537 10.0622 6.8053C10.2 6.6516 10.3113 6.51115 10.3961 6.38395C10.4809 6.25675 10.5418 6.13485 10.5789 6.01825C10.616 5.89635 10.6346 5.7665 10.6346 5.6287C10.6346 5.3584 10.5577 5.16495 10.404 5.04835C10.2503 4.93175 9.9986 4.87345 9.6488 4.87345C9.3361 4.87345 8.97305 4.91055 8.55965 4.98475L8.3609 5.01655L8.30525 4.31695C8.82995 4.16325 9.3626 4.0864 9.9032 4.0864C11.0003 4.0864 11.5488 4.574 11.5488 5.5492C11.5488 5.74 11.5276 5.9149 11.4852 6.0739C11.4481 6.2329 11.3845 6.38925 11.2944 6.54295C11.2096 6.69665 11.093 6.85565 10.9446 7.01995C10.8015 7.17895 10.6213 7.35915 10.404 7.56055L9.2831 8.6497H11.6522Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE2Icon);
export default __webpack_public_path__ + "static/media/E2-icon.eab3aabd2eea8963f9d7ad0d9c31398a.svg";
export { ForwardRef as ReactComponent };